import _ from 'lodash'

const NumberFormat = {
  convertNumberToFormat(value, theFormat) {
    return parseFloat(value || 0).toLocaleString('en-US', theFormat ? theFormat : '%0.2f')
  },
  convertFormatToNumber(value) {
    return _.replace(value || '', /[^0-9.]+/, '')
  },
}

export default {
  methods: NumberFormat
}

export {
  NumberFormat
}
